import {register} from './../exports/theme-sections';
import {popupVideo} from './../exports/popups';

const columnSection = {
  onLoad() {
    popupVideo(this.container, this.id);
  },
};

register('index-columns', columnSection);
